import { Button, BUTTON_TYPES } from '../../../../components/Button'
import { BTN_TXT } from '../../../../constants'
import { HOSPITAL_STATUS_TO_STATUS } from '../../../../components/Status'
import { ActionModal } from './ActionModal'
import { useState } from 'react'

export const HospitalActions = ({
  details,
  handleHospitalForEdit,
  outsideCommunityMode
}: {
  details
  handleHospitalForEdit
  outsideCommunityMode?: boolean
}) => {
  const [openModal, setOpenModal] = useState(false)
  const handleOpenModal = () => setOpenModal(true)
  return (
    <>
      {details.status === HOSPITAL_STATUS_TO_STATUS.active && (
        <Button
          type={BUTTON_TYPES.DEFAULT}
          onClick={handleOpenModal}
          danger
          upperCase
        >
          {BTN_TXT.ARCHIVE}
        </Button>
      )}
      {details.status === HOSPITAL_STATUS_TO_STATUS.archived && (
        <Button type={BUTTON_TYPES.DEFAULT} onClick={handleOpenModal} upperCase>
          {BTN_TXT.RE_ACTIVATE}
        </Button>
      )}
      <ActionModal
        details={details}
        handleHospitalForEdit={handleHospitalForEdit}
        openModal={openModal}
        setOpenModal={setOpenModal}
        outsideCommunityMode={outsideCommunityMode}
      />
    </>
  )
}
